export default {
  titleHeader: 'Titel'
};



// WEBPACK FOOTER //
// ./public/js/resources/de/axis.js